module.exports = __webpack_public_path__ + "img/splashScreen1_maximum.2b5dd458.jpg";